// `fk-sim-wasm` loader (11 §6.1). Browser: `init()` fetches the .wasm next to the module (Vite
// emits it as an asset). Tests/Node: `initWasmSync(bytes)`.
import init, * as wasm from 'fk-sim-wasm';

let ready: Promise<typeof wasm> | undefined;

export type Wasm = typeof wasm;

export function initWasm(): Promise<Wasm> {
  ready ??= init().then(() => wasm);
  return ready;
}

export function initWasmSync(bytes: BufferSource): Wasm {
  wasm.initSync({ module: bytes });
  ready = Promise.resolve(wasm);
  return wasm;
}

export function wasmModule(): Wasm { return wasm; }
